var map = {
	"./chainspin_footer.webp": [
		57285,
		57285
	],
	"./chokwin_footer.webp": [
		85877,
		85877
	],
	"./gannar_footer.webp": [
		63440,
		63440
	],
	"./luckykingbet_footer.webp": [
		16929,
		16929
	],
	"./mars-br_footer.webp": [
		82313,
		82313
	],
	"./mars-mx_footer.webp": [
		88410,
		88410
	],
	"./mars-pt_footer.webp": [
		34698,
		34698
	],
	"./mars-ru_footer.webp": [
		75283,
		75283
	],
	"./mars-th_footer.webp": [
		83950,
		83950
	],
	"./mars_footer.webp": [
		27534,
		27534
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95990;
module.exports = webpackAsyncContext;